/* eslint-disable no-empty */
/* eslint-disable global-require */
/* eslint-disable prefer-spread */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable no-bitwise */
/* eslint-disable no-use-before-define */
import SHA256 from 'crypto-js/sha256';
import EncryptHex from 'crypto-js/enc-hex';
import EncryptBase64 from 'crypto-js/enc-base64';
import { encrypt as AESEncrypt } from 'crypto-js/aes';
import CryptoJSCore from 'crypto-js/core';
import Pkcs7 from 'crypto-js/pad-pkcs7';
import isNullCheck from './global/isNullCheck';
import { getCryptoKey } from '../components/userProfile/utils/webViewUtils';

/**
 * @return {Object}
 */
function SecretKey() {
  const key = getCryptoKey();
  const kewWordArray = SHA256(key);
  const keyByteArray = wordArrayToByteArray(kewWordArray, 16);
  return keyByteArray;
}

/**
 * @return {String}
 */
export function generateRandomString() {
  const ALPHA_NUM =
    '9876543210ZYXWVUTSRQPONMLKJIHGFEDCBAabcdefghijklmnopqrstuvwxyz!@#$&_';
  let sb = '';
  for (let i = 0; i < 15; i++) {
    const ndx = Math.random() * ALPHA_NUM.length;
    sb += ALPHA_NUM.charAt(ndx);
  }
  localStorage.setItem('savedRandomNumer', sb);
  return sb;
}
/**
 * @param {Object} word
 * @param {Object} length
 * @return {object}
 */
function wordToByteArray(word, length) {
  const ba = [];
  let i;
  const xFF = 0xff;
  if (length > 0) ba.push(word >>> 24);
  if (length > 1) ba.push((word >>> 16) & xFF);
  if (length > 2) ba.push((word >>> 8) & xFF);
  if (length > 3) ba.push(word & xFF);

  return ba;
}
/**
 * @param {Object} wordArray
 * @param {Object} length
 * @return {object}
 */
function wordArrayToByteArray(wordArray, length) {
  if (
    wordArray.hasOwnProperty('sigBytes') &&
    wordArray.hasOwnProperty('words')
  ) {
    length = Math.min(length, wordArray.sigBytes);
    wordArray = wordArray.words;
  }

  const result = [];
  let bytes;
  let i = 0;
  while (length > 0) {
    bytes = wordToByteArray(wordArray[i], Math.min(4, length));
    length -= bytes.length;
    result.push(bytes);
    i++;
  }
  return [].concat.apply([], result);
}

/**
 * @param {Object} body
 * @param {Object} requestnumber
 * @return {string}
 */
export function getChecksum(body) {
  try {
    let hash = '';
    if (isNullCheck(body)) {
      hash = generateHash(body);
    }
    const randomRequestNumber = generateRandomString();
    const unEncValue = `${randomRequestNumber}-${hash}-${new Date().getTime()}`;
    return encrypt(unEncValue);
  } catch (e) {
    // write something here
  }
}

/**
 * @param {Object} address
 * @param {Object} requestnumber
 * @return {string}
 */
export function generateRequestHeaderForUrl(address) {
  try {
    const url = require('url');
    const q = url.parse(address, true);
    let stringForHash = q.pathname;
    const queryObj = q.query;
    const sortedQueryObj = {};
    Object.keys(queryObj)
      .sort()
      .forEach((key) => {
        sortedQueryObj[key] = queryObj[key];
      });

    Object.keys(sortedQueryObj).forEach((key, index) => {
      if (isNullCheck(key))
        stringForHash = `${stringForHash}-${key}=${sortedQueryObj[key]}`;
    });
    let hash = '';
    if (isNullCheck(stringForHash)) {
      hash = generateHash(stringForHash);
    }
    const randomRequestNumber = generateRandomString();
    const unEncValue = `${randomRequestNumber}-${hash}-${new Date().getTime()}`;
    return encrypt(unEncValue);
  } catch (e) {
    // write something here
  }
}

/**
 *
 * @param {Object} bytes
 * @return {Object}
 */
function bytesToWordArr(bytes) {
  return CryptoJSCore.lib.WordArray.create(
    bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes),
  );
}

/**
 *
 * @param {String} strToEncrypt
 * @return {String}
 */
export function encrypt(strToEncrypt) {
  const keyInByteArray = SecretKey();
  const keyInWordArray = bytesToWordArr(keyInByteArray);
  const encryptedWords = AESEncrypt(strToEncrypt, keyInWordArray, {
    iv: EncryptHex.parse('0000000000000000'),
    mode: CryptoJSCore.mode.CBC,
    padding: Pkcs7,
  });
  return EncryptBase64.stringify(encryptedWords.ciphertext);
}
/**
 *
 * @param {*} value
 * @return {string}
 */
export function generateHash(value) {
  try {
    const hashValue = SHA256(value).toString(EncryptHex);
    return hashValue;
  } catch (e) {}
}
